import type { SplitTestConfig } from './splitTestTypes';
import { hs929interstitials } from './tests/hs929interstitials';
import { hs893AdCoinBlockersSplitTest } from './tests/HS893AdCoinBlockers';
import { hs915FirstLevelsSplitTest } from './tests/HS915FirstLevels';

export const activeSplitTests: SplitTestConfig[] = [
  hs929interstitials,
  hs893AdCoinBlockersSplitTest,
  hs915FirstLevelsSplitTest,
];
